import { t } from "i18next"
import { useContext, useEffect, useState } from "react"
import { UserContext } from "../../../store/store"

import "./Tutti.scss"

const StaticRow = ({ letter, cols }) => {
  const total = cols
    .map((a) => (a.pts ? a.pts : 0))
    .reduce((acc, cur) => acc + cur)
  return (
    <>
      <tr>
        <td>{letter.toUpperCase()}</td>
        {cols.map((a, i) => (
          <td key={i}>
            {a.ans}
            {a.pts > 0 && <span className={`pts p${a.pts}`}>+{a.pts}</span>}
          </td>
        ))}
        <td className="hold">{total}</td>
      </tr>
    </>
  )
}

const DynamicRow = ({ letter, cols, data, setData, onTutti, freeze }) => {
  const set = (c, val) => {
    setData((current) => {
      let clone = { ...current }
      clone[c] = val
      return clone
    })
  }

  return (
    <>
      <tr>
        <td>{letter}</td>
        {cols.map((c, ix) => (
          <td key={ix}>
            <input
              type="text"
              disabled={freeze}
              value={data[c]}
              onChange={(e) => set(c, e.target.value)}
              className="form-control p-0 m-0"
            />
          </td>
        ))}
        <td className="hold">
          <button
            type="button"
            disabled={freeze}
            onClick={() => onTutti(data)}
            className="btn btn-primary">
            {t("games.tutti.tutti")}
          </button>
        </td>
      </tr>
    </>
  )
}

export const Tutti = ({
  me,
  game,
  letter,
  dones,
  setDones,
  onTutti,
  tuttiMsg,
  row,
  setRow,
  freeze,
  roll,
  tryAgain,
}) => {
  const [state] = useContext(UserContext),
    theme = state.theme === "light" ? "table-striped" : "table-dark"

  const [tab] = useState(me.id)

  const disabled = freeze && game.admin !== me.id,
    isDone = game.currentRound === game.rounds

  useEffect(() => {
    // cleanup func
    return () => {
      console.log("se cierra el tutti")
      setDones([])
    }
  }, [setDones])

  return (
    <>
      <center>
        <h4 className="mt-4">
          {t("games.tutti.round", {
            round: game.currentRound,
            total: game.rounds,
          })}
        </h4>
      </center>

      <div
        id="tutti-container"
        className={"mt-4 container " + (tuttiMsg ? "blurry" : "")}>
        <div className="row qt">
          <div className="outer">
            <div className="inner">
              <table
                id="tutti-table"
                className={`table table-hover w-100 ${state.theme} ${theme}`}>
                <thead>
                  <tr>
                    <th className="free">{t("games.tutti.letter")}</th>
                    {game.cols.map((c, ix) => (
                      <th key={ix}>{c}</th>
                    ))}
                    <th className="free hold">{t("games.tutti.total")}</th>
                  </tr>
                </thead>
                <tbody>
                  {dones.map((done, dix) => (
                    <StaticRow
                      key={dix}
                      letter={done.letter}
                      cols={game.cols
                        .map((c) => c.toLocaleLowerCase())
                        .map((c) => done.submits[tab.toString()][c])}
                    />
                  ))}

                  {!freeze && (
                    <DynamicRow
                      letter={letter.toUpperCase()}
                      cols={game.cols}
                      data={row}
                      setData={setRow}
                      freeze={disabled}
                      onTutti={() => onTutti(row)}
                    />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {freeze && game.admin === me.id && !isDone && (
        <div className="row my-4">
          <center>
            <button
              type="button"
              onClick={() => roll()}
              className="btn btn-primary m-3">
              {t(`games.tutti.new_round`)}
            </button>
          </center>
        </div>
      )}

      {freeze && isDone && (
        <div className="row my-4">
          <center>
            <button
              type="button"
              onClick={() => tryAgain()}
              className="btn btn-primary m-3">
              {t(`ui.btns.retry`)}
            </button>
          </center>
        </div>
      )}

      {disabled && !isDone && (
        <div className="row my-4">
          <center>
            <b>{t(`games.tutti.wating_admin`)}</b>
          </center>
        </div>
      )}
    </>
  )
}

export default Tutti
